var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0.375C1.00875 0.375 0 1.38375 0 2.625V15.375C0 16.6162 1.00875 17.625 2.25 17.625H9.75C10.9913 17.625 12 16.6162 12 15.375V12.7573C11.862 12.8953 11.3869 13.4932 10.5 13.5V15.375C10.5 15.7875 10.1625 16.125 9.75 16.125H2.25C1.8375 16.125 1.5 15.7875 1.5 15.375V2.625C1.5 2.2125 1.8375 1.875 2.25 1.875H9.75C10.1625 1.875 10.5 2.2125 10.5 2.625V4.5C11.3891 4.50675 11.8661 5.1088 12 5.24268V2.625C12 1.38375 10.9913 0.375 9.75 0.375H2.25ZM10.478 5.62427C10.286 5.62497 10.0947 5.69919 9.94922 5.84619C9.65747 6.14019 9.65888 6.61572 9.95288 6.90747L11.3049 8.25H5.60596C5.19196 8.25 4.85596 8.586 4.85596 9C4.85596 9.414 5.19196 9.75 5.60596 9.75H11.3049L9.95288 11.0925C9.65888 11.3847 9.65747 11.8591 9.94922 12.1531C10.0958 12.3008 10.2878 12.375 10.481 12.375C10.6722 12.375 10.8639 12.303 11.0098 12.1575L13.6531 9.53247C13.7948 9.39185 13.875 9.19987 13.875 9C13.875 8.80013 13.7948 8.60853 13.6531 8.46753L11.0098 5.84253C10.8628 5.69647 10.67 5.62356 10.478 5.62427Z",
    fill: "#55535B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.2555b66abcc9ff0bcce8c7a9b97058ee.svg";
export { ForwardRef as ReactComponent };